import { Header, Paragraph } from '@eggplant/pattern-library'

const MonitorAvailabilityDashboard = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Monitor Availability
    </Header>
    <Paragraph>
      This page breaks down the test cases in your selected monitor configuration, showing the run time data of it's test case runs over a specified period.
    </Paragraph>
  </div>

export default MonitorAvailabilityDashboard
